/**
 * Run async tasks with bounded concurrency. Preserves task→result order.
 *
 * Used by Step 1 to fan out CPT resolution across many parallel BFF calls
 * without stampeding the Auth0 token-refresh path.
 */
export const runConcurrent = async <T>(
  tasks: Array<() => Promise<T>>,
  limit: number,
): Promise<T[]> => {
  const results: T[] = new Array(tasks.length);
  if (tasks.length === 0) return results;
  let cursor = 0;
  const workerCount = Math.min(Math.max(1, limit), tasks.length);
  const workers = Array.from(
    { length: workerCount },
    async (): Promise<void> => {
      while (cursor < tasks.length) {
        const i = cursor;
        cursor += 1;
        results[i] = await tasks[i]();
      }
    },
  );
  await Promise.all(workers);
  return results;
};
